import { render } from "./DiscountPanelCard.vue?vue&type=template&id=c0bc9318&scoped=true"
import script from "./DiscountPanelCard.vue?vue&type=script&lang=js"
export * from "./DiscountPanelCard.vue?vue&type=script&lang=js"

import "./DiscountPanelCard.vue?vue&type=style&index=0&id=c0bc9318&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bc9318"]])

export default __exports__